module.exports = __webpack_public_path__ + "img/rsd.2595eadd.png";